import { type Accessor, createMemo } from "/npm/solid-js@^1.9.5/+esm";
import { type ICustomElement } from "/npm/component-register@^0.8.7/+esm";

import { type ValidHybridPath } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/hooks/useFullPropertyPath.js";
import { formatValue, type Format } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/utils/index.js";
import { useCartValue } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/hooks/useCartValue.js";

type Options = {
  path: Accessor<ValidHybridPath>;
  format?: Format;
  element: HTMLElement & ICustomElement;
};

export function useFormattedValue(options: Options) {
  const value = useCartValue({ path: options.path, element: options.element });

  const formattedValue = createMemo(() => {
    const v = value();
    if (v === null) return null;
    if (
      typeof v === "string" ||
      typeof v === "number" ||
      typeof v === "boolean"
    ) {
      return formatValue(options.format || "", v);
    }
    console.warn(
      options.element,
      `useFormattedValue: Unsupported value type. Expected string, number, or boolean. Received: ${typeof v}.`,
      v,
    );
    return null;
  });

  return formattedValue;
}
